"use strict";
/*
const exampleData = {
    "repeatLevels": {"c1": [0, 9.398666], "c2": [9.398666, 16.248608], "c3": [16.248608, 23.098549], "c4": [23.098549, 29.94849], "c5": [29.94849, 36.79843], "c6": [36.79843, 43.648373], "c7": [43.648373, 50.498314], "c8": [50.498314, 57.348255], "c9": [57.348255, 64.1982], "c10": [64.1982, 71.048134], "c11": [71.048134, 77.89807], "c12": [77.89807, 84.74801], "c13": [84.74801, 91.597946], "c14": [91.597946, 100]},
    "retentionPeriods": [0, 1, 2, 3, 7, 14, 21, 30],
    "consistency": true,
    "initialDate": 1608336000842,
    "retention": [[2001, 1957, 767, 450, 366, 222, 148, 128, 51], [2089, 2032, 831, 506, 395, 238, 155, 136], [2307, 2252, 909, 574, 399, 267, 169, 151], [2255, 2220, 916, 525, 359, 267, 192, 151], [2174, 2125, 806, 447, 355, 257, 169, 133], [1976, 1928, 694, 455, 337, 230, 170, 152], [1879, 1829, 673, 435, 338, 204, 169, 115], [2137, 2086, 823, 532, 399, 281, 194, 156], [2400, 2335, 931, 590, 423, 270, 204, 155], [2591, 2541, 1035, 662, 524, 326, 217, 83], [2616, 2564, 1048, 641, 456, 355, 229], [2461, 2403, 954, 562, 453, 255, 201], [2283, 2228, 867, 560, 436, 266, 164], [1878, 1818, 750, 439, 353, 230, 148], [2165, 2115, 880, 541, 407, 299, 194], [2463, 2407, 983, 604, 440, 304, 199], [2668, 2609, 1074, 669, 495, 368, 120], [2371, 2319, 969, 624, 487, 318], [2402, 2353, 996, 580, 453, 313], [2445, 2403, 1021, 602, 486, 304], [2692, 2642, 1081, 691, 532, 328], [2927, 2866, 1140, 727, 551, 333], [2842, 2780, 1069, 633, 509, 282], [2611, 2563, 1065, 689, 565, 154], [2584, 2542, 1102, 657, 488], [2439, 2394, 1055, 617, 458], [2456, 2416, 1041, 662, 479], [2295, 2248, 914, 531, 189], [2188, 2154, 835, 262], [2344, 2294, 498], [939, 919]]
}
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionCalculations = void 0;
const lodash_1 = __importDefault(require("lodash"));
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const ICEventQueryUtil_1 = require("src/hello_assets/src/util/ICEventQueryUtil");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const CommonTypesI18N_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesI18N");
const calculateClassicSeries = (request, response, filterCohortDays) => {
    // console.log("=========== calculateClassicSeries ->", response, filterCohortDays);
    const calculateClassicSeriesStart = performance.now();
    const retentionType = request.retentionType;
    const initialDateMillis = response.intervalStartTimeSec * 1000;
    const cohortCheckEndDays = 0;
    let allDataLoaded = false;
    let maxPeriods = 0;
    let avgCohortSizeTotal = 0;
    let avgCohortCounter = 0;
    let incompleteDataCalculatedAvg = false;
    const retention = response.retention;
    const chartSeries = [];
    const cohortName = ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariants(request.cohortQuery);
    const returnName = ICEventQueryUtil_1.ICEventQueryUtil.stringifyQueryEventVariants(request.returnQuery);
    if (filterCohortDays.avg) {
        if (!!process.env.IS_TEST_SERVER) {
            console.log("start", { retention, retentionType, initialDateMillis });
        }
        if (retention) {
            for (let rowIndex = 0; rowIndex < retention.length; rowIndex++) {
                if (retention[rowIndex] && retention[rowIndex].length > maxPeriods) {
                    maxPeriods = retention[rowIndex].length;
                }
                if (retention[rowIndex] && retention[rowIndex].length > 0) {
                    const allDataLoadedAvg = isCohortComplete(initialDateMillis, rowIndex, cohortCheckEndDays);
                    if (incompleteDataCalculatedAvg || allDataLoadedAvg) {
                        avgCohortSizeTotal += retention[rowIndex][0];
                        avgCohortCounter++;
                    }
                    else if (!allDataLoaded && avgCohortSizeTotal === 0) {
                        avgCohortSizeTotal += retention[rowIndex][0];
                        avgCohortCounter++;
                        incompleteDataCalculatedAvg = true;
                    }
                }
            }
        }
        if (!!process.env.IS_TEST_SERVER) {
            console.log("1: ", { maxPeriods, incompleteDataCalculatedAvg, avgCohortSizeTotal, avgCohortCounter, periods: response.retentionPeriods });
        }
        const avgData = [];
        const retentionSizes = [];
        const totalCohortSizes = [];
        const significantRetentionCounts = [];
        const zones = [];
        const seriesDataAvailabilityStates = [];
        for (let retentionPeriodAvg = 1; retentionPeriodAvg < maxPeriods /*<= response.retentionPeriods.length*/; retentionPeriodAvg++) {
            const periodDay = response.retentionPeriods[retentionPeriodAvg - 1];
            if (!!process.env.IS_TEST_SERVER) {
                console.log("==== for retentionPeriodAvg", { retentionPeriodAvg, periodDay });
            }
            let totalCohortSize = 0;
            let totalRetentionSize = 0;
            let significantRetentionCount = 0;
            let incompleteDataCalculated = false;
            for (let avgRowIndex = 0; avgRowIndex < retention.length; avgRowIndex++) {
                // console.log("------------ avgRowIndex", avgRowIndex);
                const nextPeriodData = retention[avgRowIndex];
                if (nextPeriodData && nextPeriodData.length > 0 && nextPeriodData[0] > 0 && retentionPeriodAvg < nextPeriodData.length) {
                    const fullCohortLoaded = isCohortComplete(initialDateMillis, avgRowIndex, cohortCheckEndDays);
                    const fullPeriodLoaded = isFullPeriodLoaded(initialDateMillis, avgRowIndex, retentionType, periodDay);
                    allDataLoaded = fullCohortLoaded && fullPeriodLoaded;
                    // console.log("allDataLoaded", {periodDay, retentionPeriodAvg, avgRowIndex, totalCohortSize, value:nextPeriodData[retentionPeriodAvg], fullCohortLoaded, fullPeriodLoaded, allDataLoaded});
                    if (incompleteDataCalculated || allDataLoaded) {
                        totalCohortSize += nextPeriodData[0];
                        totalRetentionSize += nextPeriodData[retentionPeriodAvg];
                        significantRetentionCount++;
                    }
                    else if (!allDataLoaded && totalCohortSize === 0) {
                        totalCohortSize += nextPeriodData[0];
                        totalRetentionSize += nextPeriodData[retentionPeriodAvg];
                        significantRetentionCount++;
                        incompleteDataCalculated = true;
                    }
                }
            }
            if (totalCohortSize > 0) {
                let avgValue;
                retentionSizes.push(totalRetentionSize);
                totalCohortSizes.push(totalCohortSize);
                significantRetentionCounts.push(significantRetentionCount);
                if (totalRetentionSize > 0) {
                    avgValue = parseFloat((totalRetentionSize / totalCohortSize * 100).toFixed(2));
                }
                else if (totalCohortSize > 0) {
                    avgValue = 0;
                }
                else {
                    avgValue = null;
                }
                if (incompleteDataCalculated) {
                    avgData.push({
                        y: avgValue,
                        custom: {
                            incompleteData: true
                        },
                    });
                    seriesDataAvailabilityStates.push("incomplete");
                    zones.push({
                        value: retentionPeriodAvg - 1,
                        dashStyle: "Dot"
                    });
                }
                else {
                    avgData.push({
                        y: avgValue,
                    });
                    seriesDataAvailabilityStates.push(avgValue === null ? "noData" : "complete");
                    zones.push({
                        value: retentionPeriodAvg - 1,
                        dashStyle: "Solid"
                    });
                }
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("total", { incompleteDataCalculated, totalCohortSize, totalRetentionSize, significantRetentionCount, avgData: [...avgData], zones: [...zones] });
                }
            }
        }
        if (avgData.length > 0) {
            // console.log("seriesDataAvailabilityStates", seriesDataAvailabilityStates);
            (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataAvailabilityStateMarkers)(avgData, seriesDataAvailabilityStates);
            (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataIncompleteMarkers)(avgData, seriesDataAvailabilityStates, chartSeries.length);
            let avgCohort;
            if (avgCohortSizeTotal === 0 || avgCohortCounter === 0) {
                avgCohort = 0;
            }
            else {
                avgCohort = parseInt((avgCohortSizeTotal / avgCohortCounter).toFixed(0));
            }
            chartSeries.push({
                type: "spline",
                data: avgData,
                name: `${cohortName} ${CommonTypesI18N_1.CommonTypesI18N.constants.highchartsArrow} ${returnName}, AVG`,
                zoneAxis: 'x',
                zones: (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesZones)(zones),
                custom: {
                    isAvg: true,
                    cohortSize: avgCohort,
                    retentionSizes: retentionSizes,
                    totalCohortSizes: totalCohortSizes,
                    significantRetentionCounts: significantRetentionCounts
                }
            });
        }
    }
    /**
     * params.filterCohortDays.daysShift приходят как дневной сдвиг от от "initialDateMillis"
     */
    const selectedDaysIndexes = filterCohortDays.daysShift.map(value => value);
    const allDaysIndexes = lodash_1.default.range(retention.length).map(value => value);
    lodash_1.default.each(allDaysIndexes, selectedRowIndex => {
        const selectedDayMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(initialDateMillis).startOf("day").add(selectedRowIndex, "day");
        const periodName = selectedDayMoment.format(DateTimeFacade_1.DateTimeFormatByFunctionality.HumanReadable.Common.DateOnly); //periodDaysModelDays[selectedRowIndex]
        // const periodName = periodDaysModelDays[selectedRowIndex]
        if (retention && selectedRowIndex < retention.length && retention[selectedRowIndex][0] > 0) {
            const dayData = retention[selectedRowIndex];
            const cohortSize = dayData[0];
            const pointValues = [];
            const seriesDataAvailabilityStates = [];
            const retentionSizes = [];
            for (let retentionPeriodIndex = 1; retentionPeriodIndex < dayData.length; retentionPeriodIndex++) {
                const retentionSize = dayData[retentionPeriodIndex];
                retentionSizes.push(retentionSize);
                const value = parseFloat((retentionSize / cohortSize * 100).toFixed(2));
                if (isCohortComplete(initialDateMillis, selectedRowIndex, cohortCheckEndDays)
                    && isFullPeriodLoaded(initialDateMillis, selectedRowIndex, retentionType, response.retentionPeriods[retentionPeriodIndex - 1])) {
                    pointValues.push({ y: value });
                    seriesDataAvailabilityStates.push("complete");
                }
                else {
                    seriesDataAvailabilityStates.push("incomplete");
                    pointValues.push({ y: value });
                }
            }
            if (pointValues.length > 0) {
                (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataIncompleteMarkers)(pointValues, seriesDataAvailabilityStates, chartSeries.length);
                const seriesColor = (0, HighchartsCalculationsCommonUtils_1.getSeriesColorFromGlobalColors)(chartSeries.length);
                (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataAvailabilityStateMarkers)(pointValues, seriesDataAvailabilityStates);
                chartSeries.push({
                    color: seriesColor,
                    type: 'spline',
                    name: `${cohortName} ${CommonTypesI18N_1.CommonTypesI18N.constants.highchartsArrow} ${returnName}, ${periodName}`,
                    custom: {
                        isAvg: false,
                        cohortSize: cohortSize,
                        retentionSizes: retentionSizes,
                        date: periodName,
                        dayShift: selectedRowIndex
                    },
                    data: pointValues,
                    visible: lodash_1.default.includes(selectedDaysIndexes, selectedRowIndex),
                    showInLegend: lodash_1.default.includes(selectedDaysIndexes, selectedRowIndex)
                });
            }
        }
    });
    const calculateClassicSeriesDuration = Number.parseFloat((performance.now() - calculateClassicSeriesStart).toFixed(2));
    if (!!process.env.IS_TEST_SERVER) {
        console.log(`retention calculateClassicSeries in ${calculateClassicSeriesDuration}ms`);
    }
    if (lodash_1.default.isEmpty(chartSeries)) {
        return {
            series: [],
            chartStatus: { status: "noData" }
        };
    }
    return {
        series: chartSeries,
    };
};
const calculateOvertimeSeries = (request, response, filterPeriod) => {
    // console.log("=========== calculateOvertimeSeries ->", response, /*filterCohortDays*/);
    const calculateOvertimeSeriesStart = performance.now();
    const chartSeries = [];
    const intervalName = CommonTypesI18N_1.CommonTypesI18N.retentionType.retentionTypeTypeToIntervalName(CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeToRetentionTypeType(request.retentionType));
    if (!lodash_1.default.isEmpty(filterPeriod)) {
        if (!lodash_1.default.isEmpty(response.retention) && !lodash_1.default.isEmpty(response.retentionPeriods)) {
            const retentionType = request.retentionType;
            const initialDateMillis = response.intervalStartTimeSec * 1000;
            const cohortCheckEndDays = 0;
            if (!!process.env.IS_TEST_SERVER) {
                console.log("start", { retention: response.retention, retentionPeriods: response.retentionPeriods, cohortCheckEndDays });
            }
            const initialMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(initialDateMillis).startOf("day");
            const initialMomentDate = initialMoment.toDate();
            // const initialMomentMillis = initialMoment.clone().valueOf()
            if (!!process.env.IS_TEST_SERVER) {
                console.log("1", { initialDateMillis, initialMoment_valueOf: initialMoment.valueOf(), initialMoment: initialMoment.toString(), initialMomentDate: initialMomentDate.toUTCString(), initialMomentDateMillis: initialMomentDate.getTime() });
            }
            lodash_1.default.each(response.retentionPeriods, (currentRetentionPeriod, currentRetentionPeriodIndex) => {
                // console.log("currentRetentionPeriodIndex====", currentRetentionPeriodIndex);
                const zones = [];
                const seriesData = [];
                const retentionSizes = [];
                const cohortSizes = [];
                const seriesDataAvailabilityStates = [];
                const currentPeriodSelectedInFilter = lodash_1.default.includes(filterPeriod, currentRetentionPeriod);
                let hasAtLeastOneSignificantDataPoint = false;
                let prevPointMillis = 0;
                for (let rowIndex = 0; rowIndex < response.retention.length; rowIndex++) {
                    const dayData = response.retention[rowIndex];
                    const pointMillis = initialMoment.clone().add(seriesData.length, "day").valueOf();
                    if (currentRetentionPeriodIndex < dayData.length - 1) {
                        hasAtLeastOneSignificantDataPoint = true;
                        const cohortSize = dayData[0];
                        const retentionSize = dayData[currentRetentionPeriodIndex + 1];
                        retentionSizes.push(retentionSize);
                        cohortSizes.push(cohortSize);
                        let value;
                        if (retentionSize > 0 && cohortSize > 0) {
                            value = parseFloat((retentionSize / cohortSize * 100).toFixed(2));
                        }
                        else {
                            value = parseFloat((0).toFixed(2));
                        }
                        if (isCohortComplete(initialDateMillis, rowIndex, cohortCheckEndDays)
                            && isFullPeriodLoaded(initialDateMillis, rowIndex, retentionType, response.retentionPeriods[currentRetentionPeriodIndex])) {
                            seriesData.push({ x: pointMillis, y: value });
                            zones.push({
                                value: pointMillis,
                                dashStyle: "Solid"
                            });
                            seriesDataAvailabilityStates.push("complete");
                        }
                        else {
                            seriesData.push({ x: pointMillis, y: value });
                            zones.push({
                                value: pointMillis,
                                dashStyle: "Dot"
                            });
                            seriesDataAvailabilityStates.push("incomplete");
                        }
                    }
                    else {
                        retentionSizes.push(null);
                        cohortSizes.push(null);
                        const noDataValue = null;
                        seriesData.push({ x: pointMillis, y: noDataValue });
                        seriesDataAvailabilityStates.push("noData");
                    }
                    prevPointMillis = pointMillis;
                }
                if (seriesData.length > 0 && hasAtLeastOneSignificantDataPoint) {
                    (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataIncompleteMarkers)(seriesData, seriesDataAvailabilityStates, chartSeries.length);
                    (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesDataAvailabilityStateMarkers)(seriesData, seriesDataAvailabilityStates);
                    const seriesColor = (0, HighchartsCalculationsCommonUtils_1.getSeriesColorFromGlobalColors)(chartSeries.length);
                    chartSeries.push({
                        type: 'spline',
                        color: seriesColor,
                        name: `${intervalName} ${currentRetentionPeriod}`,
                        custom: {
                            day: currentRetentionPeriod,
                            cohortSizes: cohortSizes,
                            retentionSizes: retentionSizes,
                            periodIndex: currentRetentionPeriodIndex,
                            hasAtLeastOneSignificantDataPoint: hasAtLeastOneSignificantDataPoint
                        },
                        data: seriesData,
                        zoneAxis: 'x',
                        zones: (0, HighchartsCalculationsCommonUtils_1.analyzeSeriesZones)(zones),
                        visible: currentPeriodSelectedInFilter,
                        showInLegend: currentPeriodSelectedInFilter
                    });
                }
            });
        }
    }
    const calculateOvertimeSeriesDuration = Number.parseFloat((performance.now() - calculateOvertimeSeriesStart).toFixed(2));
    if (!!process.env.IS_TEST_SERVER) {
        console.log(`retention calculateOvertimeSeries in ${calculateOvertimeSeriesDuration}ms`);
    }
    if (lodash_1.default.isEmpty(chartSeries)) {
        return {
            series: [],
            chartStatus: { status: "noData" }
        };
    }
    return {
        series: chartSeries,
    };
};
// const dateToDays = function (date: Date): number {
//     return Math.floor(date.getTime() / 86_400_000);
// };
const isCohortComplete = function (initialDateMillis, rowIndex, cohortCheckEndDays) {
    if (true) {
        const todayMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentTime();
        const endPeriodMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(initialDateMillis).add(rowIndex + cohortCheckEndDays, "day");
        const before = endPeriodMoment.isBefore(todayMoment, "day");
        // console.log("isCohortComplete: ", {before, todayMoment:todayMoment.format(), endPeriodMoment:endPeriodMoment.format()});
        return before;
    }
    else {
        const endPeriodInMillis = initialDateMillis + (rowIndex + cohortCheckEndDays) * DateTimeFacade_1.DAY_IN_MILLIS;
        const startOfTodayInMillis = DateTimeFacade_1.DateTimeFacade.getStartOfTodayMilliseconds();
        const diffWithNow = startOfTodayInMillis - endPeriodInMillis;
        const isBefore = diffWithNow > 0;
        return isBefore;
    }
};
const isFullPeriodLoaded = function (initialDateMillis, rowIndex, retentionType, retentionPeriod) {
    const retentionPeriodLength = getRetentionPeriodLength(retentionType);
    const daysOffset = rowIndex + retentionPeriodLength * retentionPeriod + (retentionPeriodLength - 1);
    if (true) {
        const todayMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentTime();
        const endPeriodMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(initialDateMillis).add(daysOffset, "day");
        const before = endPeriodMoment.isBefore(todayMoment, "day");
        // console.log("isFullPeriodLoaded: ", {before, daysOffset, todayMoment:todayMoment.format(), endPeriodMoment:endPeriodMoment.format()});
        return before;
    }
    else {
        const endPeriodInMillis = initialDateMillis + (daysOffset) * DateTimeFacade_1.DAY_IN_MILLIS;
        const startOfTodayInMillis = DateTimeFacade_1.DateTimeFacade.getStartOfTodayMilliseconds();
        const diffWithNow = startOfTodayInMillis - endPeriodInMillis;
        const isBefore = diffWithNow > 0;
        return isBefore;
    }
};
exports.RetentionCalculations = {
    calculateClassicSeries,
    calculateOvertimeSeries,
    // dateToDays,
    isCohortComplete,
    isFullPeriodLoaded,
};
////////////////////////////////////////////////
// Private
////////////////////////////////////////////////
const getRetentionPeriodLength = function (retentionType) {
    const retentionTypeType = CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeToRetentionTypeType(retentionType);
    switch (retentionTypeType) {
        case "nDay":
            return 1;
        case "nWeek":
            return 7;
        case "nMonth":
            return 30;
    }
    return 1;
};
